import type { components } from '~/api/OnPremAgentClient/generated-schema'
import OnPremAgentAPI from '../OnPremAgentClient/OnPremAgentAPI'

export type Dataset = components['schemas']['Dataset']
export type DefaultSuccessResponse = components['schemas']['DefaultSuccessResponse']
export type GetRuntimeResponse = components['schemas']['LastExecutionTimeResponse'] & {
  next_executed_time?: string | null
}

class CronjobAPI extends OnPremAgentAPI {
  getRuntimeDatasetVerification = (): Promise<GetRuntimeResponse> => {
    return this.client.GET(`/api/cronjob/get_last_runtime/dataset_verification`, {})
  }
  getNextRuntimeDatasetVerification = (): Promise<GetRuntimeResponse> => {
    return this.client.GET(`/api/cronjob/get_next_runtime/dataset_verification`, {})
  }

  scheduleDatasetVerification = () => {
    return this.client.POST('/api/cronjob/dataset_verification/schedule_now', {})
  }
}

export default CronjobAPI
